export default {
    paises() {
        return {
            1: 'R.U. GRAN BRETAÑA E IRL.NORTE',
            2: 'ESTADOS UNIDOS DE AMERICA',
            3: 'REP. FEDERAL DE ALEMANIA',
            4: 'FRANCIA',
            5: 'SUIZA',
            6: 'BELGICA',
            7: 'ITALIA',
            8: 'PAISES BAJOS',
            9: 'ESPAÑA',
            10: 'URUGUAY',
            11: 'CHILE',
            12: 'BRASIL',
            13: 'AUSTRIA',
            14: 'ANDORRA',
            15: 'DINAMARCA',
            16: 'PORTUGAL',
            17: 'CANADA',
            18: 'UNITED ARAB EMIRATES',
            19: 'IMPERIO DE JAPON',
            20: 'AFGHANISTAN',
            21: 'AUSTRALIA',
            22: 'ANTIGUA AND BARBUDA',
            23: 'ANGUILLA',
            24: 'IRLANDA',
            25: 'ALBANIA',
            26: 'PARAGUAY',
            27: 'SUECIA',
            28: 'NORUEGA',
            29: 'CROACIA',
            30: 'ARMENIA',
            31: 'ANGOLA',
            32: 'ANTARCTICA',
            33: 'MEXICO',
            34: 'AMERICAN SAMOA',
            35: 'ARUBA',
            36: 'ALAND ISLANDS',
            37: 'FINLANDIA',
            38: 'AZERBAIJAN',
            39: 'ISRAEL',
            40: 'BOSNIA AND HERZEGOVINA',
            41: 'REPUBLICA DE BOLIVIA',
            42: 'BARBADOS',
            43: 'LUXEMBURGO',
            44: 'COREA',
            45: 'BANGLADESH',
            46: 'BURKINA FASO',
            47: 'ECUADOR',
            48: 'LAS BAHAMAS',
            49: 'BULGARIA',
            50: 'BAHRAIN',
            51: 'CUBA',
            52: 'BURUNDI',
            53: 'BENIN',
            54: 'COLOMBIA',
            55: 'COSTA RICA',
            56: 'TAIWAN',
            57: 'SAINT BARTHELEMY',
            58: 'EL SALVADOR',
            59: 'BERMUDA',
            60: 'BRUNEI DARUSSALAM',
            61: 'BONAIRE, SINT EUSTATIUS AND SA',
            62: 'BHUTAN',
            63: 'HONDURAS',
            64: 'BOUVET ISLAND',
            65: 'BOTSWANA',
            66: 'PUERTO RICO',
            67: 'NICARAGUA',
            68: 'BELARUS',
            69: 'REPUBLICA DE PANAMA',
            70: 'BELIZE',
            71: 'COCOS (KEELING) ISLANDS',
            73: 'CENTRAL AFRICAN REPUBLIC',
            74: 'CONGO',
            77: 'CAMEROON',
            78: 'CAPE VERDE',
            79: 'VENEZUELA',
            80: 'ARGENTINA',
            81: 'CURAÃAO',
            82: 'CHRISTMAS ISLAND',
            83: 'CHINA',
            84: 'CYPRUS',
            85: 'CZECH REPUBLIC',
            86: 'DJIBOUTI',
            87: 'DOMINICA',
            88: 'REPUBLICA DOMINICANA',
            89: 'ALGERIA',
            90: 'ESTONIA',
            91: 'EGYPT',
            92: 'WESTERN SAHARA',
            93: 'ERITREA',
            94: 'ETHIOPIA',
            95: 'FIJI',
            96: 'FALKLAND ISLANDS (MALVINAS)',
            97: 'MICRONESIA, FEDERATED STATES O',
            98: 'FAROE ISLANDS',
            99: 'GABON',
            100: 'GRENADA',
            101: 'GEORGIA',
            102: 'FRENCH GUIANA',
            103: 'GUERNSEY',
            104: 'GHANA',
            105: 'GIBRALTAR',
            106: 'GREENLAND',
            107: 'GAMBIA',
            108: 'GUINEA',
            109: 'GUADELOUPE',
            110: 'EQUATORIAL GUINEA',
            111: 'GREECE',
            112: 'SOUTH GEORGIA AND THE SOUTH SA',
            113: 'GUATEMALA',
            114: 'GUAM',
            115: 'GUINEA-BISSAU',
            116: 'GUYANA',
            117: 'HONG KONG',
            118: 'HEARD ISLAND AND MCDONALD ISLA',
            119: 'HAITI',
            120: 'HUNGARY',
            121: 'INDONESIA',
            122: 'ISLE OF MAN',
            123: 'LIECHTENSTEIN',
            124: 'INDIA',
            125: 'BRITISH INDIAN OCEAN TERRITORY',
            126: 'IRAQ',
            127: 'IRAN',
            128: 'ICELAND',
            129: 'JERSEY',
            130: 'JAMAICA',
            131: 'JORDAN',
            132: 'KENYA',
            133: 'KYRGYZSTAN',
            134: 'CAMBODIA',
            135: 'KIRIBATI',
            136: 'COMOROS',
            137: 'SAINT KITTS AND NEVIS',
            138: 'KOREA',
            139: 'KUWAIT',
            140: 'KAZAKHSTAN',
            142: 'LEBANON',
            143: 'SAINT LUCIA',
            144: 'SRI LANKA',
            145: 'LIBERIA',
            146: 'LESOTHO',
            147: 'LITHUANIA',
            148: 'LATVIA',
            149: 'LIBYAN ARAB JAMAHIRIYA',
            150: 'MOROCCO',
            151: 'MONACO',
            152: 'MOLDOVA, REPUBLIC OF',
            153: 'MONTENEGRO',
            154: 'SAINT MARTIN (FRENCH PART)',
            155: 'MADAGASCAR',
            156: 'MARSHALL ISLANDS',
            157: 'MACEDONIA, THE FORMER YUGOSLAV',
            158: 'MALI',
            159: 'MYANMAR',
            160: 'MONGOLIA',
            161: 'MACAO',
            162: 'NORTHERN MARIANA ISLANDS',
            163: 'MARTINIQUE',
            164: 'MAURITANIA',
            165: 'MONTSERRAT',
            166: 'MALTA',
            167: 'MAURITIUS',
            168: 'MALDIVES',
            169: 'MALAWI',
            170: 'MALAYSIA',
            171: 'MOZAMBIQUE',
            172: 'NAMIBIA',
            173: 'NEW CALEDONIA',
            175: 'NORFOLK ISLAND',
            176: 'NIGERIA',
            177: 'NEPAL',
            178: 'NAURU',
            179: 'NIUE',
            180: 'NEW ZEALAND',
            181: 'OMAN',
            182: 'PERU',
            183: 'FRENCH POLYNESIA',
            184: 'PAPUA NEW GUINEA',
            185: 'PHILIPPINES',
            186: 'PAKISTAN',
            187: 'POLAND',
            188: 'SAINT PIERRE AND MIQUELON',
            189: 'PITCAIRN',
            190: 'PALESTINIAN TERRITORY, OCCUPIE',
            191: 'PALAU',
            192: 'QATAR',
            193: 'RÉUNION',
            194: 'ROMANIA',
            195: 'SERBIA',
            196: 'RUSSIAN FEDERATION',
            197: 'RWANDA',
            198: 'ISLAS CAIMANES',
            199: 'SAUDI ARABIA',
            200: 'SOLOMON ISLANDS',
            201: 'SEYCHELLES',
            202: 'SUDAN',
            203: 'SINGAPORE',
            204: 'SAINT HELENA',
            205: 'SLOVENIA',
            206: 'SVALBARD AND JAN MAYEN',
            207: 'SLOVAKIA',
            208: 'SIERRA LEONE',
            209: 'SAN MARINO',
            210: 'SENEGAL',
            211: 'SOMALIA',
            212: 'SURINAME',
            213: 'SOUTH SUDAN',
            214: 'SAO TOME AND PRINCIPE',
            215: 'SINT MAARTEN (DUTCH PART)',
            216: 'SYRIAN ARAB REPUBLIC',
            217: 'SWAZILAND',
            218: 'TURKS AND CAICOS ISLANDS',
            219: 'CHAD',
            220: 'FRENCH SOUTHERN TERRITORIES',
            221: 'TOGO',
            222: 'THAILAND',
            223: 'TAJIKISTAN',
            224: 'TOKELAU',
            225: 'TIMOR-LESTE',
            226: 'TURKMENISTAN',
            227: 'TUNISIA',
            228: 'TONGA',
            229: 'TURKEY',
            230: 'TRINIDAD AND TOBAGO',
            231: 'TUVALU',
            232: 'TANZANIA',
            233: 'UKRAINE',
            234: 'UGANDA',
            236: 'UZBEKISTAN',
            239: 'VIRGIN ISLANDS, BRITISH',
            240: 'VIRGIN ISLANDS, U.S.',
            241: 'VIET NAM',
            242: 'VANUATU',
            243: 'WALLIS AND FUTUNA',
            244: 'SAMOA',
            245: 'YEMEN',
            246: 'MAYOTTE',
            247: 'SOUTH AFRICA',
            248: 'ZAMBIA',
            249: 'ZIMBABWE',
            999: 'OTROS PAISES'
        }
    },
    provincias() {
        return {
            1: 'CAPITAL FEDERAL',
            2: 'BUENOS AIRES',
            3: 'CATAMARCA',
            4: 'CORDOBA',
            5: 'CORRIENTES',
            6: 'CHACO',
            7: 'CHUBUT',
            8: 'ENTRE RIOS',
            9: 'FORMOSA',
            10: 'JUJUY',
            11: 'LA PAMPA',
            12: 'LA RIOJA',
            13: 'MENDOZA',
            14: 'MISIONES',
            15: 'NEUQUEN',
            16: 'RIO NEGRO',
            17: 'SALTA',
            18: 'SAN JUAN',
            19: 'SAN LUIS',
            20: 'SANTA CRUZ',
            21: 'SANTA FE',
            22: 'SANTIAGO DEL ESTERO',
            23: 'TUCUMAN',
            40: 'TIERRA DEL FUEGO'
        }
    },
    actividades() {
        return {
            100: 'AGRICULT, GANADER, CAZA Y SILVIC0',
            110: 'CULTIVOS Y SERVICIOS AGRICOLAS',
            120: 'CRIA ANIMALES Y SERV.PECUARIOS',
            130: 'CAZA / CAPT.ANIM./ SILVIC./ MADERA',
            200: 'PESCA Y SERVICIOS CONEXOS',
            300: 'EXPLOTACION MINAS Y CANTERAS',
            310: 'EXP.MINAS / CANT(EXC.PETROL GAS)',
            320: 'EXTRACC / COMERC PROD.DERIV PETR',
            400: 'INDUSTRIA MANUFACTURERA',
            410: 'ELAB.ALIMENTICIOS Y BEBIDAS',
            420: 'FAB.PROD.TEXTILES / PRENDAS / PIEL',
            430: 'FAB.SUSTANCIAS / PROC.QUIMICOS',
            440: 'FAB.MAQ./ EQ.ELECT / RADIOS / MED.',
            450: 'FAB.AUTOMOVILES / REMOLQUES',
            460: 'OTROS',
            510: 'ELECT./ GAS / VAPOR Y AGUA CALIEN',
            520: 'CAPTAC / DEPURAC / DISTRIBUC.AGUA',
            600: 'CONSTRUCCION',
            700: 'COMERC.MAYOR MENOR, REPAR AUTOM',
            710: 'VTA.REPARAC.AUTOS / VTA COMBUST',
            720: 'COMERCIO AL POR MAYOR',
            730: 'COMERCIO AL POR MENOR',
            810: 'HOTELERIA Y RESTAURANTES',
            820: 'TRANSPORTE / ALMACENAM / COMUNICAC',
            830: 'INTERMEDIACION FINANCIERA',
            840: 'INMOBILIARIA / EMPRESAR / ALQUILER',
            850: 'ADM.PUBLICA / DEFENSA / SEG.SOCIAL',
            860: 'ENSEÑANZA / SOCIALES / DE SALUD',
            870: 'OTROS SERVICIOS',
            900: 'PERSONAS FISICAS NO COMPRENDIDO'
        }
    }
};